import React from 'react';



// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const RichText = ({ content }) => {


    return (
        <div className={cn('wrapper')}>
            <div className={cn('content')} dangerouslySetInnerHTML={{ __html: content }}></div>
        </div>
    );
};

export default RichText;